import { render, staticRenderFns } from "./AsinListing.vue?vue&type=template&id=396594c8&scoped=true"
import script from "./AsinListing.vue?vue&type=script&lang=js"
export * from "./AsinListing.vue?vue&type=script&lang=js"
import style0 from "./AsinListing.vue?vue&type=style&index=0&id=396594c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396594c8",
  null
  
)

export default component.exports